import { createContext, useContext } from 'react';

const NotificationContext = createContext({});

export const useNotificationProvider = () => {
    return NotificationContext.Provider;
}

export const useNotification = () => {
    return useContext(NotificationContext)
}